const MinusIcon = ({
  className = "",
  strokeWidth = 4
}: {
  className?: string;
  strokeWidth?: number;
}) => <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={2.5} stroke='currentColor' className={`${className} inline-block`} role='img' aria-labelledby='accordionCloseIconTitle' data-sentry-element="svg" data-sentry-component="MinusIcon" data-sentry-source-file="MinusIcon.tsx">
    <title id='accordionCloseIconTitle'>Accordion close icon</title>
    <path strokeLinecap='round' strokeLinejoin='round' d='M5 12h14' strokeWidth={strokeWidth} data-sentry-element="path" data-sentry-source-file="MinusIcon.tsx" />
  </svg>;
export default MinusIcon;